module.exports = __webpack_public_path__ + "c_static/img/1-2手机淘宝收藏夹.5f489ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/1-2手机淘宝收藏夹.jpg
// module id = L5I/
// module chunks = 33